import { request } from '@/http'
import { HTTPResponse } from '@/types/common'
import {
  CollectionVO,
  CollectionModuleVO,
  CollectionModuleRes,
  CurrentAccountVO,
} from '@/types/collection-module'
import { STATUS_TYPE } from '@/constants/collection-module'

const baseURL = '/metis-flying/api'
const membershipURL = '/metis-atlas-membership/api'

// 查看收集单下数据详情
export function getCollectionModule<T>(moduleId: string | number) {
  return request({
    baseURL,
    url: '/external/data-collection-forms/module',
    method: 'GET',
    params: {
      moduleId,
    },
  }).then((res) => res.data as HTTPResponse<CollectionModuleRes<T>>)
}

// 保存数据详情
export function saveCollectionModule<T>(moduleId: string | number, data: T) {
  return request({
    baseURL,
    url: '/external/data-collection-forms/module/save',
    method: 'POST',
    params: {
      moduleId,
    },
    data,
  }).then((res) => res.data as HTTPResponse<undefined>)
}

// 提交审核状态
export function submitCollectionModule(moduleId: string | number) {
  return request({
    baseURL,
    url: '/external/data-collection-forms/module/status/submit',
    method: 'POST',
    params: {
      moduleId,
    },
  }).then((res) => res.data as HTTPResponse<undefined>)
}

// 撤回审核状态
export function revertCollectionModule(moduleId: string | number) {
  return request({
    baseURL,
    url: '/external/data-collection-forms/module/status/revert',
    method: 'POST',
    params: {
      moduleId,
    },
  }).then((res) => res.data as HTTPResponse<undefined>)
}

// 查看收集单列表
export function getCollections(statuses: STATUS_TYPE[]) {
  return request({
    baseURL,
    url: '/external/data-collection-forms/tenant',
    method: 'GET',
    params: {
      statuses,
    },
  }).then((res) => res.data as HTTPResponse<CollectionVO[]>)
}

// 查看收集单下模块列表
export function getCollectionModules(dataCollectionFormId: string | number) {
  return request({
    baseURL,
    url: `/external/data-collection-forms/tenant/${dataCollectionFormId}/module/`,
    method: 'GET',
  }).then((res) => res.data as HTTPResponse<CollectionModuleVO[]>)
}

// 查看当前登录信息
export function getCurrentAccount() {
  return request({
    baseURL,
    url: '/external/auth/current',
    method: 'GET',
  }).then((res) => res.data as HTTPResponse<CurrentAccountVO>)
}

// 获取可用年级
export function getMclassGrades() {
  return request({
    baseURL: membershipURL,
    url: '/collection/form/mclasses/grades',
    method: 'GET',
  }).then((res) => res.data as HTTPResponse<Record<string | number, string>>)
}

// 批量提交审核状态
export function batchSubmitCollectionModule(moduleIdList: Array<string | number>) {
  return request({
    baseURL,
    url: '/external/data-collection-forms/module/status/submit-batch',
    method: 'POST',
    data: { moduleIdList },
  }).then((res) => res.data as HTTPResponse<void>)
}

// 批量撤回审核状态
export function batchRevertCollectionModule(moduleIdList: Array<string | number>) {
  return request({
    baseURL,
    url: '/external/data-collection-forms/module/status/revert-batch',
    method: 'POST',
    data: { moduleIdList },
  }).then((res) => res.data as HTTPResponse<void>)
}
